import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { TenderingService } from 'src/app/services/tendering/tendering.service';
import { Enquiryheader } from 'src/app/model/enquiryheader.model';
import { NgForm, FormsModule, FormGroup, FormBuilder } from '@angular/forms';
import { Enquiryline } from 'src/app/model/enquiryline.model';
import { UserService } from 'src/app/services/user/user.service';
import { DataSharingService } from 'src/app/auth/data-sharing.service';
import { isNullOrUndefined } from 'util';
import { EnlistmentService } from 'src/app/services/enlistment/enlistment.service';

@Component({
  selector: 'app-techprice',
  templateUrl: './techprice.component.html',
  styleUrls: ['./techprice.component.css']
})
export class TechpriceComponent implements OnInit {

  stepno: string;
  enquiryData: any;
  enquiryHeader: Enquiryheader;

  data: Enquiryline[];
  form: FormGroup;
  vendorDocs: any;


  constructor(private router: Router, private route: ActivatedRoute,
    private tenderingServices: TenderingService, private fb: FormBuilder,
    private enlistmentServices: EnlistmentService) {
    this.stepno = this.route.snapshot.params.enquiryid;

    this.form = this.fb.group({
      avatar: null
    });

  }

  ngOnInit() {
    this.getEnquiryById();
  }

  getEnquiryById() {
    this.tenderingServices.GetEnquiryById(this.stepno).subscribe(
      datas => {
        this.enquiryData = datas;
        this.enquiryHeader = this.enquiryData;
        this.enquiryHeader.behalfOf = "DEE Piping Systems.";
        this.data = this.enquiryHeader.enquiryLine;
        this.getVendorDocs();
        console.log(this.data);
      }
    )
  }

  SubmitTechPriceQuoteForm(form: NgForm) {

    this.enquiryHeader.enquiryLine = this.data;
    this.enquiryHeader.quoteType = "both";
    this.enquiryHeader.id = 0;

    for (var i = 0; i < this.enquiryHeader.enquiryLine.length; i++) {
      this.enquiryHeader.enquiryLine[i].quoteType = "both";
      this.enquiryHeader.enquiryLine[i].vendorNo = this.enquiryHeader.vendorNo;
      this.enquiryHeader.enquiryLine[i].id = 0;
    }

    //console.log(this.enquiryHeader);

    this.tenderingServices.InviteTechPriceQuote(this.enquiryHeader).subscribe(
      data => {
        alert("Successfully Submitted");
      }
    );

  }

  //for uploading technical specification starts
  uploadDocument() {
    let input = new FormData();
    input.append('avatar', this.form.get('avatar').value);
    input.append('documentType', 'TechnicalSpecs');
    input.append('module', 'Enquiry');
    input.append('applicationNumber', this.enquiryHeader.enquiryNo);

    this.enlistmentServices.UploadVendorDocument(input).subscribe(
      (data: any) => {
        if (data == true) {
          this.getVendorDocs();
        }
        else {

        }
      }
    );

  }

  getVendorDocs() {
    let inputs = new FormData();
    inputs.append('applicationNumber', this.enquiryHeader.enquiryNo);
    this.enlistmentServices.GetVendorDocs(inputs).subscribe(
      (data: any) => {
        this.vendorDocs = data;
        console.log(this.vendorDocs);
      }
    );
  }

  removeDoc = function (id) {
    this.enlistmentServices.removeVendorDocs(id).subscribe(
      (data: any) => {
        if (data == true) {
          this.getVendorDocs();
        }
        else {

        }
      }
    );
  }

  onFileChange(event) {
    //alert("selected");
    if (event.target.files.length > 0) {
      let file = event.target.files[0];
      this.form.get('avatar').setValue(file);

      console.log(this.form.get('avatar').value);
    }
  }

  //for uploading technical specifications ends

}
